import { computed, ref, Ref } from 'vue';
import { ValidationProperties } from '@/models/validation.interface';
import { ModalErrorStates } from '@/models/modal/modal.enum';
import validationPresenter from '@/presenters/validation-presenter';
import datePresenter from'@/presenters/date-presenter';
import store from '@/store';

export default class DateEndCode {
	public datePicker: Ref<HTMLInputElement | null> = ref(null);

	public isFieldValidatedAndMissing = computed((): boolean => {
		return validationPresenter.isPropertyMissing(ValidationProperties.END_DATE);
	});

	public isFieldValidatedAndInvalid = computed((): boolean => {
		const info = store.getters.validationInfoDates();
		return info.invalidTypes.includes(ValidationProperties.END_DATE);
	});

	public shouldFieldBeDisabled = computed((): boolean => {
		return datePresenter.shouldEndDateBeDisabled.value;
	});

	private startDate = computed((): Date | null => {
		return store.getters.startDate();
	});

	private endDate = computed((): Date | null => {
		return store.getters.endDate();
	});

	public prefillDatePicker(): void {
		if (!this.datePicker.value || !this.endDate.value) {
			return;
		}

		this.datePicker.value.value = datePresenter.transformDateObjectToUTCDateString(this.endDate.value);
	}

	public setDate(event: { target: { value: string | null } }): void {
		if (!event.target?.value) {
			return;
		}

		const date = datePresenter.transformUTCDateStringToDateObject(event.target.value);
		store.mutations.setEndDate(date);

		if (this.isFieldValidatedAndMissing.value) {
			validationPresenter.validateMandatoryFields();
		}

		if (this.isFieldValidatedAndInvalid.value) {
			store.mutations.resetValidationInfoDates();
		}

		if (this.startDate.value && datePresenter.doAnyCustomProductDatesFallOutsideBounds(this.startDate.value, date)) {
			store.mutations.setModalErrorState(ModalErrorStates.CUSTOM_PRODUCT_DATE_OUT_OF_BOUNDS);
		}
	}
}
